import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Container, Row, Col } from 'react-bootstrap';

const parts = [
    {
        title: 'Expert Team Building',
        description: 'A core team of 13 professionals and a network of 48 subject matter experts specializing in water, sanitation, environment, and gender — driving impactful initiatives in WASH, NRM, livelihood, and climate-resilient agriculture.',
    },
    {
        title: 'Promoting Nature-Based Solutions',
        description: 'Focus on Nature-Based Solutions (NBS) by leveraging effective capacity building, appropriate technologies, and local resources to solve complex environmental issues.',
    },
    {
        title: 'Advancing Equity and Inclusion',
        description: 'Ensuring gender equity and social inclusion in all interventions and projects, with special focus on empowering women, youth, and vulnerable communities.',
    },
    {
        title: 'Delivering Integrated Services',
        description: 'Providing services including solid and liquid waste management, water conservation and drinking water solutions, agricultural development, and women empowerment.',
    },
];

export const MissionStatement = () => {
    return (
        <Container style={{ paddingTop: '20px', paddingBottom: '10px' }}>
            <h2 className="text-center mb-2" style={{ color: '#2E7D32' }}>Our Mission</h2>
            <p className="text-center mb-0" style={{ maxWidth: '800px', margin: '0 auto', fontSize: '1.05rem' }}>
                PSGS mission centers on empowering underserved communities through innovative, community-driven
                solutions that promote economic independence, ecological balance, and social equity.
            </p>
        </Container>
    );
};

export const GuidingPillars = () => {
    const [inView, setInView] = useState([false, false, false, false]);

    const handleScroll = () => {
        const scrollPositions = [false, false, false, false];
        parts.forEach((_, index) => {
            const element = document.getElementById(`circle-${index}`);
            if (element) {
                const rect = element.getBoundingClientRect();
                if (rect.top <= window.innerHeight && rect.bottom >= 0) {
                    scrollPositions[index] = true;
                }
            }
        });
        setInView(scrollPositions);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <Container className="mission-container">
            <h4 className="text-center mb-4" style={{ color: '#388E3C' }}>Our Guiding Pillars</h4>
            <Row className="justify-content-center">
                {parts.map((part, index) => (
                    <Col xs={12} md={6} key={index} className="mb-4">
                        <motion.div
                            id={`circle-${index}`}
                            className="mission-circle"
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{
                                opacity: inView[index] ? 1 : 0,
                                scale: inView[index] ? 1 : 0.9,
                            }}
                            transition={{
                                type: 'spring',
                                stiffness: 100,
                                damping: 25,
                                delay: index * 0.3,
                            }}
                        >
                            <div className="circle-content" style={{
                                backgroundColor: '#E8F5E9',
                                borderLeft: '4px solid #2E7D32',
                                padding: '20px',
                                borderRadius: '8px',
                                minHeight: '150px'
                            }}>
                                <h3 style={{ color: '#2E7D32' }}>{part.title}</h3>
                                <p>{part.description}</p>
                            </div>
                        </motion.div>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

const Mission = () => {
    return (
        <>
            <MissionStatement />
            <GuidingPillars />
        </>
    );
};

export default Mission;
